export default __webpack_public_path__ + "static/media/PRY.175e37a1.svg";